import React from "react";
import "./ORAL_SURGERY.css";
import Teeth_Whiting_img from "../images/dental-assisting-3392127_1920.jpg";
export default function ORAL_SURGERY() {
  return (
    <div className="container_Oral">
      <h1>Oral Surgery</h1>
      <div className="img_box_Oral">
        <img src={Teeth_Whiting_img} className="img_of_Oral" alt="" />
      </div>
      <div className="text_main_Oral">
        <p>
          {" "}
          Oral medicinal method is consistently performed in a dental office
          setting under anaesthesia. Oral Surgery can go from routine
          methodologies, for instance, tooth extractions and implant plan to
          more flighty jaw realignment therapeutic methodology and emergency
          care for facial damage. Before your oral medical procedure is
          performed, x-rays will frequently be taken to help in determination
          and treatment. A well-ordered clarification of the methodology
          alongside your anaesthesia choices will be examined, and you should
          not hesitate to make any inquiries you have.
        </p>
        <h1>DID YOU KNOW??</h1>
        <p>
          While some may be stressed to go under the blade, the dominant part of
          oral medical procedure patients are most worried about the "needle" of
          sedation and general anaesthesia. So is dental sedation safe? The
          appropriate response is yes! The Oral Surgeons have more anaesthesia
          preparing than some other dental experts and they are more than fit
          the bill to convey protected and powerful sedation to their patients.
          They are authorized to give Intravenous Sedation and General
          Anaesthesia.
        </p>

        <div className="FAQ_Service_Oral">
          <h2>FAQ'S</h2>
        </div>
      </div>
    </div>
  );
}
